// extracted by mini-css-extract-plugin
module.exports = {"statusNotFound":"styles_statusNotFound__21zt3","removeForMobile":"styles_removeForMobile__CY3xP"};